import { ModuleType } from '@lib/types/course-modules'

type Props = Pick<ModuleType, 'topicsCovered'>

const ModuleTopics = ({ topicsCovered }: Props) => (
  <div className="flex space-x-2 lg:items-center">
    <span className="lg:my-0 py-1">Topics:</span>
    <div className="flex space-x-1 items-center flex-wrap">
      {topicsCovered.map((topic) => (
        <p
          key={topic}
          className="bg-grey-200 border border-grey-400 rounded-md px-2 my-1 lg:text-base text-sm"
        >
          {topic}
        </p>
      ))}
    </div>
  </div>
)

export default ModuleTopics
